<template>
  <div id="consultarprogramacoeswrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Programações de Eventos Festivos" :botoes="botoesHeader" breakpoint="xl" />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form @submit.prevent="filtrarProgramacoes" @reset.prevent="limparFiltros">
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-nome-evento" label-size="md" label="Nome do Evento">
                  <b-form-input v-model="filtros.nomeEvento"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-tipo" label-size="md" label="Tipo do Evento">
                  <b-form-select id="select-filtros-tipo" v-model="filtros.idTipo" :options="tipoEvento">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="2" class="pt-4">
                <b-button type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
              <b-col cols="6" lg="2" class="pt-4">
                <b-button type="submit" :disabled="tableBusy">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>
        <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
          sort-by="" :sort-desc="true" striped stacked="xl" show-empty>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-sm-none" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item @click="detalhesProgramacao(row.item.IdProgramacao)">
                <font-awesome-icon icon="eye" />
                <span>Detalhes</span>
              </b-dropdown-item>
              <b-dropdown-item @click="editarProgramacao(row.item)">
                <font-awesome-icon icon="edit" />
                <span>Editar</span>
              </b-dropdown-item>
              <b-dropdown-item @click="detalhesProgramacao(row.item.IdProgramacao, true)">
                <font-awesome-icon icon="trash" />
                <span>Excluir</span>
              </b-dropdown-item>
            </b-dropdown>
            <div class="actions-icons lgvert d-none d-sm-flex">
              <b-link class="text-dark" @click="detalhesProgramacao(row.item.IdProgramacao)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Detalhes</div>
              </b-link>
              <b-link class="text-dark" @click="editarProgramacao(row.item)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <b-link class="text-dark" @click="detalhesProgramacao(row.item.IdProgramacao, true)">
                <font-awesome-icon icon="trash" />
                <div style="font-size: 12px">Excluir</div>
              </b-link>
            </div>
          </template>
        </b-table>
        <table-pagination v-if="totalRows > 10" :total-rows="totalRows" :per-page="10" @pageChange="pageChange" />
      </b-card-body>
    </b-card>
    <!-- <modal-anular-contrato v-if="exibirModalAnulacao" :idContrato="idContratoSelecionado.toString()"
      @fecharModal="toggleModalAnulacao" @refresh="atualizarLista"></modal-anular-contrato>
    <modal-importar-contrato v-if="exibirModalImportacao" @fecharModal="toggleModalImportacao" @refresh="atualizarLista"/> -->
  </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import programacaoService from '@/services/eventos/programacaoService';
import eventoService from '@/services/licitacoes/eventosService';
import { store } from "@/store";
import { BotaoSagres } from '@/types/botao-sagres';
import { FiltrosProgramacoes } from "@/types/eventos/programacao/filtros-programacao";
import { Programacao } from "@/types/eventos/programacao/programacao"
import { fieldsProgramacoesEventoConsulta } from '@/types/eventos/programacao/fields-programacao';
import { TableField } from '@/types/table-field';
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';

const CompProps = Vue.extend({
  name: 'ConsultarProgramacoes',
  components: { CardFiltrosBusca, HeaderSagres, TablePagination }
})

@Component
export default class ConsultarProgramacoes extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsProgramacoesEventoConsulta
  items: Programacao[] = []
  filtros: FiltrosProgramacoes = new FiltrosProgramacoes()

  tipoEvento: any[] = []

  currentPage = 1
  pageSize = 10
  totalRows = 0

  tableBusy = false
  idProgramacaoSelecionada = 0
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'plus',
      texto: 'Nova Programação',
      url: '/modulo-eventos/programacoes/editar',
    }
  ]


  async mounted() {
    try {
      store.blockScreen = true
      const responseTipoEvento = await eventoService.listarTiposEvento()
      this.tipoEvento = [{ value: null, text: 'TODOS' }, ...responseTipoEvento.data.map(t => ({ value: t.IdTipoEvento, text: t.DeTipoEvento }))]

      await this.loadData()

    }
    catch (e) {
      console.error(e)
    }
    finally {
      store.blockScreen = false
    }

  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async pageChange(value) {
    this.currentPage = value;
    await this.loadData();
  }

  async loadData(): Promise<void> {
    let response: any = null;
    response = await programacaoService.filtrarProgramacoes(
      this.currentPage,
      this.pageSize,
      this.filtros
    );

    if (response) {
      this.totalRows = response.totalRows;

      this.items = response.programacoes.map(function (p: any) {
        const retorno = Object.assign(new Programacao(), p)
        return retorno
      })
    } else {
      this.$toast.error("Erro ao obter a lista de contratos");
    }
    this.tableBusy = false;
  }

  async detalhesProgramacao(idProgramacao: number, excluir = false) {
      this.$router.push('/modulo-eventos/programacoes/detalhes/' + idProgramacao + (excluir ? '?excluir' : ''))
  }
  async editarProgramacao(item: Programacao) {
        this.$router.push('/modulo-eventos/programacoes/editar/' + item.IdProgramacao)
  }
  /* async removerLicitacao(IdLicitacao) {
      console.log('call removerLicitacao', IdLicitacao)
      await this.sleep(2000)
    } */

  /**
   * chamado quando um COF é anulado, colapsa os detalhes e refaz a paginação.
   */
  atualizarLista(): void {
    this.loadData()
  }

  async limparFiltros() {
    //console.log('call limparFiltros')
    this.filtros.limpar();
  }
  async filtrarProgramacoes() {
    this.pageChange(1);
  }
};
</script>

<style scoped></style>